import { cn } from "@/lib/utils";
import { TimeSlot } from "@/types/bookinghome";
import { Clock } from "lucide-react";

interface TimeSlotSelectorProps {
  timeSlots: TimeSlot[];
  selectedTimeSlot?: TimeSlot;
  onSelectTimeSlot: (timeSlot: TimeSlot) => void;
}

const TimeSlotSelector = ({
  timeSlots,
  selectedTimeSlot,
  onSelectTimeSlot,
}: TimeSlotSelectorProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {timeSlots.map((slot) => (
        <div
          key={slot.id}
          className={cn(
            "time-slot",
            slot.capacity.available > 0 ? "available" : "unavailable",
            selectedTimeSlot?.id === slot.id && "selected"
          )}
          onClick={() => {
            if (slot.capacity.available > 0) {
              onSelectTimeSlot(slot);
            }
          }}
        >
          <div className="flex items-center space-x-2 text-lg font-medium mb-2">
            <Clock className="h-5 w-5" />
            <span>
              {slot.startTime} - {slot.endTime}
            </span>
          </div>
          <div className="text-sm text-muted-foreground">
            {slot.capacity.available > 0 ? (
              <span>Available</span>
            ) : (
              <span>Fully booked</span>
            )}
          </div>
          <div className="mt-2 text-sm font-medium">
            From {slot.price.adult.currency} {slot.price.adult.amount} per adult
          </div>
        </div>
      ))}
    </div>
  );
};

export default TimeSlotSelector;